import { jwtDecode } from 'jwt-decode';

const SECOND_AS_MS = 1000;

interface TokenInput {
  accessToken: string;
  roles: string[];
}

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

interface ImpersonationResponse {
  tokenType: string;
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
  roles: string[];
  validTo: number;
  isUserImpersonate: boolean;
}

export const setImpersonationRequest = (
  token: TokenInput
): ImpersonationResponse => {
  const dataFromToken = jwtDecode<DecodedToken>(token.accessToken);
  const today = new Date();
  const expireDay = new Date(dataFromToken.exp * SECOND_AS_MS);

  return {
    tokenType: 'Bearer',
    accessToken: token.accessToken,
    expiresIn: expireDay.getTime() - today.getTime(),
    refreshToken: '',
    roles: token.roles,
    validTo: dataFromToken.exp,
    isUserImpersonate: true
  };
};
